import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import View from './view';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { GetStaff } from 'careand-redux/selectors';

const FaxDetails = (props) => {
  const { fax, onChanged, onClose } = props;

  const [resending, setResending] = useState(false);
  const [archiving, setArchiving] = useState(false);

  const dispatch = useAppDispatch();

  const patientId = fax.patient_id;

  const patient = useAppSelector((state) => state.patients.byId[patientId]);
  const staff = useAppSelector((state) => GetStaff(state, fax.author_id, false));

  useEffect(() => {
    if (!patient) dispatch(api.Patients.getPatient({ id: patientId }));
  }, [dispatch, patient, patientId]);

  async function onResend(number, comments) {
    setResending(true);
    await dispatch(api.Fax.resendFax({ id: fax.id, number, stringResource: { value: comments } }), {
      errorTitle: 'Re-send Fax',
    });
    setResending(false);
    if (onChanged) onChanged();
    if (onClose) onClose();
  }

  async function onArchive() {
    setArchiving(true);
    await dispatch(api.Fax.archiveFax({ id: fax.id }));
    setArchiving(false);
    if (onChanged) onChanged();
  }

  return (
    <View
      {...props}
      staff={staff}
      patient={patient}
      fax={fax}
      onResend={onResend}
      resending={resending}
      onArchive={onArchive}
      archiving={archiving}
    />
  );
};

FaxDetails.propTypes = {
  fax: PropTypes.object.isRequired,
  allowExpand: PropTypes.bool,
  autoLoad: PropTypes.bool,
};

FaxDetails.defaultProps = {
  autoLoad: true,
};

export default FaxDetails;
